import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=002cdea0&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002cdea0')) {
      api.createRecord('002cdea0', component.options)
    } else {
      api.reload('002cdea0', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=002cdea0&", function () {
      api.rerender('002cdea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Library/Builder/Components/Template.vue"
export default component.exports